export default __webpack_public_path__ + "static/media/psi-bdp-token.090b04f8.png";